import { createFileRoute } from "@tanstack/react-router";
import { LicensePage } from "@client/components/settings/license/license-page";

export const Route = createFileRoute("/_app/settings/license")({
  component: LicensePage,
});
